module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kuu3C"))).then(() => parcelRequire('ikE14'));